<template>
    <b-card no-body>

        <v-table    ref="table"
                    pagination="server"
                    :excel-callback="excel"
                    name="not-assigned-employee"
                    :items-provider="provider"
                    :fields="fields"></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
    },
    data() {
        return {
            fields:[
                { name:"Ad Soyad",key:"FullName",thClass:'w-100' },
            ],
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Employee.NotAssignedTable(data)
        },
        excel(){
            this.$refs.table.setExcelLoading(true)
            EmployeeOperationsApi.Employee.NotAssignedExcel().then(res=>{
                Additional.DownloadFile(res.data,'Atanmamış Personel.xlsx')
                this.$refs.table.setExcelLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.setExcelLoading(false)
            })
        }
    }
}
</script>

<style>

</style>